import styled, { css } from 'styled-components';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

import ImageBlock from 'components/structure/ImageBlock';

export const StyledImageBlock = styled(ImageBlock)`
  align-self: center;
  img {
    max-height: 284px;
    max-width: 284px;
  }

  ${breakpointsMedia({
    sm: css`
      img {
        max-width: initial;
        max-height: 337px;
        width: unset;
      }
    `,
    md: css`
      img {
        max-width: initial;
        max-height: 431px;
        width: 100%;
      }
    `,
    lg: css`
      img {
        max-width: initial;
      }
    `,
  })}
`;

StyledImageBlock.displayName = 'StyledImageBlock';
